{
    "Accessibility menu": "Tillgänglighetsmeny",
    "Close": "Stäng",
    "Content adjustments": "Anpassa innehåll",
    "Navigation adjustments": "Anpassa navigering",
    "Text Align": "Text Align",
    "Align Left": "Vänsterjustera",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Justera textstorlek",
    "Highlight Title": "Framhäv titel",
    "Highlight Links": "Framhäv länkar",
    "Readable Font": "Läsbart teckensnitt",
    "Colour adjustments": "Anpassa färger",
    "Dark Contrast": "Mörk kontrast",
    "Light Contrast": "Ljus kontrast",
    "High Contrast": "Hög kontrast",
    "High Saturation": "Hög mättnad",
    "Low Saturation": "Låg mättnad",
    "Monochrome": "Monokrom",
    "Tools": "Verktyg",
    "Reading Guide": "Läslinjal",
    "Big Cursor": "Stor muspekare",
    "Increase Font Size": "Öka textstorlek",
    "Decrease Font Size": "Minska textstorlek",
    "Letter Spacing": "Teckenavstånd",
    "Line Height": "Radhöjd",
    "Font Weight": "Teckensnitt tjocklek",
    "Dyslexia Font": "Dyslektiskt teckensnitt",
    "Language": "Språk",
    "Accessibility widget": "Öppna tillgänglighetsmeny",
    "Accessibility Profiles": "Tillgänglighetsprofiler",
    "Cognitive Disability": "Kognitiv funktionsnedsättning",
    "Seizure Safe": "Anfallssäker",
    "Accessibility statement": "Tillgänglighetsutlåtande",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Hindra animationer",
    "Animation paused": "Animering pausad",
    "Reset all settings": "Nollställ inställningar",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
